export function getPasswordStrength(pass) {
    let score = 0;
    if (!pass) return score;

    const validations = {
        length: pass.length >= 8,
        number: /[0-9]/.test(pass),
        lowercase: /[a-z]/.test(pass),
        uppercase: /[A-Z]/.test(pass),
        specialChar: /[^a-zA-Z0-9]/.test(pass),
    };

    if (validations.length) score++;
    if (validations.number) score++;
    if (validations.lowercase && validations.uppercase) score++;
    if (validations.specialChar) score++;

    return score;
} 